//components/sourceButton.tsx :

import React, { useState } from 'react';
import {
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Link,
} from '@mui/material';

import useI18n from '../hooks/useI18n';

interface Source {
  name?: string;
  content?: string;
  link?: string;
}

interface SourceButtonProps {
  source: Source;
}

const SourceButton: React.FC<SourceButtonProps> = ({ source }) => {
  const [open, setOpen] = useState(false);
  const t = useI18n();

  if (!source) return null;

  return (
    <>
      <div className="mt-2 flex items-center gap-1">
        {/* <SourceIcon className="w-4 h-4 text-gray-500 mr-1 opacity-70" /> */}
        <Chip
          label="Source"
          size="small"
          variant="outlined"
          clickable
          onClick={() => setOpen(true)}
          className="border-gray-300 text-gray-600 opacity-90 h-auto cursor-pointer text-[0.7rem] sm:text-[0.75rem]"
        />
      </div>

      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>{t.getCitation('dialogTitle')}</DialogTitle>
        <DialogContent>
          <Typography variant="subtitle2" gutterBottom>
            <strong>Source:</strong> {source.name || 'Unknown Source'}
          </Typography>

          {source.link && (
            <Typography variant="body2" gutterBottom>
              <strong>{t.getCitation('link')}: </strong>
              <Link
                href={source.link}
                target="_blank"
                rel="noopener noreferrer"
                style={{ wordBreak: 'break-all' }}
              >
                {/* Display the link text without the 'external://' prefix */}
                {source.link.startsWith('external://')
                  ? source.link.substring('external://'.length)
                  : source.link}
              </Link>
            </Typography>
          )}

          {source.content && (
            <Typography
              variant="body2"
              sx={{
                mt: 2,
                whiteSpace: 'pre-line',
                backgroundColor: '#f9f9f9',
                padding: '0.75rem',
                borderRadius: '8px',
                fontSize: '0.875rem',
                lineHeight: '1.5',
                maxHeight: '20rem',
                overflow: 'scroll',
              }}
            >
              {source.content}
            </Typography>
          )}

          <Typography variant="caption" color="textSecondary" sx={{ mt: 2, display: 'block' }}>
            {t.getCitation('transparencyNotice')}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SourceButton;
